import React, { useContext, useState } from 'react';
import SimpleContext from './../../context/SimpleContext';
import { Button, Modal } from 'react-bootstrap';
import './../../products/Fresh/FreshDialog.css';
import config from './../../../services/config.json';
import Counter3 from './../../products/counter/Counter3';
import NumberFormat from 'react-number-format';
import './../../products/Fresh/FreshList.css';



const FreshSearchProduct = ({name, image, id}) => {

    const context = useContext(SimpleContext);

    const [modalShow, setModalShow] = useState(false); 
    let FreshPro = [...context.products];
    
    const FreshProducts = FreshPro.filter(pr => pr.name.includes(name) && pr.IsFresh === 1);
    return ( 
        <>
        <div className="imageAndTitleFresh">
            <div className="freshimagePlace">
                <img src={`${config.ApyCategoryPictures}/${image}.jpg`} className="freshImg" alt=""/>
            </div>
            <div className="freshTitlePlace">
                <p>
                    {name}
                </p>
            </div>
        </div>

        <div className="freshTablePlace">
            <table className="table" onClick={() => setModalShow(true)}>
                {
                    FreshProducts.map((fr,i) => (
                        <tr key={i} className="tableRow">
                            <td className="td1">{fr.name}</td>
                            <td className="td2"><NumberFormat value={fr.price} displayType={'text'} thousandSeparator={true} /> ريال</td>
                        </tr>
                    ))
                }
            </table>
        </div>

        <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            centered

            >
                <Modal.Header style={{padding:"2%"}}>
                        <Modal.Title id="contained-modal-title-vcenter"
                        className="HeaderDialog"
                        >
                            <img src={`${config.ApyCategoryPictures}/${image}.jpg`} className="DialogImg" alt="FreshPic"/>
                            <p>{name}</p>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{padding:"2%", height:"400px", overflowY:"scroll"}}>
                {
                    context.FreshSearchedProducts.map((fr,i) => (
                        <div className="DialogProducts">
                            <div className="titleDialogProducts">
                                <p>{fr.name}</p>
                                <p><NumberFormat value={fr.price} displayType={'text'} thousandSeparator={true} /> ريال</p>
                            </div>
                            <div className="counterPlace">
                                <Counter3 min={fr.minimum} max={fr.maximum} unit={fr.unit} stock={fr.stock}/>
                            </div>
                        </div>
                    ))
                }
                </Modal.Body>
                    <Modal.Footer style={{padding:"0"}}>
                        <Button onClick={() => setModalShow(false)} className="DialogButton">تایید</Button>
                    </Modal.Footer>
        </Modal>
    </> 
     );
}
 
export default FreshSearchProduct;